export interface GenreCount {
  hommes: number;
  femmes: number;
  nonRenseigne: number;
  total: number;
}

export interface CertificatStat {
  id: string;
  nom: string;
  effectif: GenreCount;
  connectes: GenreCount;
  jamaisConnectes: GenreCount;
  effectifFode: number;
}

export interface CertificatStatPourcentage {
  nom: string;
  effectif: GenreCount;
  connectes: GenreCount;
  jamaisConnectes: GenreCount;
}

export const CERTIFICATS_STATS_MOCK: CertificatStat[] = [];